import {
    drawPointsAnim,
    drawLineAnim,
    drawCircleAnim,
    rotateCircleAnim,
    drawAngleAnim,
    addCustomDelay
} from "../../../../../../src/animation/Circle/helpers/drawHelpers";

import { INITIAL_RADIANS } from "../../types/Config";
import { normalizeRadian } from "../../../../../../src/utils/math/normalizeRadian";
import { ContextType } from "../../types/Interface";


export async function runCircleAnimation(context: ContextType, onComp: () => void) {
    const {
        circle,
        LineManager,
        PointManager,
        AngleManager,
        cCoord,
    } = context;

    [AngleManager].forEach(manager => manager.setAllVisible(false));

    const centerPoint = PointManager.getPoints()[0];
    const centerPointCoord = PointManager.getPointsCoord()[0];
    const pointsCoord = PointManager.getRedPointsCoord();
    const chordsPoints = PointManager.getChordsPoints();
    const chordAPoints = chordsPoints[0];
    const chordBPoints = chordsPoints[1];
    const RedPoints = PointManager.getRedPoints();
    const initialRadian = PointManager.getInitialRadians();
    const angles = AngleManager.getAngles();


    AngleManager.draw(chordsPoints);
    circle.setRadians([INITIAL_RADIANS[0], INITIAL_RADIANS[0]]);


    drawPointsAnim([centerPoint]);

    await drawCircleAnim(circle, INITIAL_RADIANS[0] + Math.PI * 2, 0, true, cCoord);
    await drawLineAnim(LineManager.lines[2], centerPointCoord, pointsCoord[0]);
    await drawLineAnim(LineManager.lines[0], chordAPoints[0], chordAPoints[2]);

    LineManager.lines[0].draw(chordAPoints[0], chordAPoints[1]);
    LineManager.lines[1].draw(chordAPoints[1], chordAPoints[2]);
    await addCustomDelay(500);

    LineManager.lines[0].setVisibleOfEqualSymbol(true);
    LineManager.lines[1].setVisibleOfEqualSymbol(true);
	await addCustomDelay(200);

    await drawLineAnim(LineManager.lines[5], centerPointCoord, pointsCoord[1]);
    await drawLineAnim(LineManager.lines[3], chordBPoints[0], chordBPoints[2]);

    LineManager.lines[3].draw(chordBPoints[0], chordBPoints[1]);
    LineManager.lines[4].draw(chordBPoints[1], chordBPoints[2]);
    await addCustomDelay(500);

    LineManager.lines[3].setVisibleOfEqualSymbol(true);
    LineManager.lines[4].setVisibleOfEqualSymbol(true);
	await addCustomDelay(200);
    await drawAngleAnim(angles[0], "x");
    await drawAngleAnim(angles[1], "x");
    await rotateCircleAnim((v) => PointManager.setRadian(Array(2).fill("").map(((_, rI) => ({ pTag: RedPoints[rI].tag, radian: normalizeRadian(initialRadian[rI] + v) })))));
    await drawPointsAnim(RedPoints);

    onComp();
}